import { useId } from 'react';
import type { ReactNode } from 'react';
import './Switch.css';

interface SwitchProps {
  label?: ReactNode;
  checked: boolean;
  onChange: (checked: boolean) => void;
  id?: string;
  className?: string;
  disabled?: boolean;
}

// Shared toggle switch (bigger than the Bootstrap default). Used everywhere a
// form-switch was hand-rolled, so the size/look stays consistent.
export function Switch({ label, checked, onChange, id, className, disabled }: SwitchProps) {
  const auto = useId();
  const sid = id ?? auto;
  return (
    <div className={`form-check form-switch finkit-switch mb-0${className ? ` ${className}` : ''}`}>
      <input
        className="form-check-input"
        type="checkbox"
        role="switch"
        id={sid}
        checked={checked}
        disabled={disabled}
        onChange={(e) => onChange(e.target.checked)}
      />
      {label != null && (
        <label className="form-check-label" htmlFor={sid}>
          {label}
        </label>
      )}
    </div>
  );
}
